module.exports = __webpack_public_path__ + "vue-dist/img/logo.bafe7356.png";